<ng-container *ngIf="inView" [ngTemplateOutlet]="template">
</ng-container>